import { defineStore } from 'pinia'   
import { computed, ref, Ref } from 'vue'
import { UserDependentStore } from './UserDependentStore'

import { DEBUG, EquipmentApi } from '@/util';
import { IEquipmentMasterDataWithDocCountDTO } from '@/types/equipment';

/** store (cache) of "my devices" for the currently active user  */
export const useMyEquipmentsStore = defineStore('myEquipmentsStore', () => {
    /********************************************************************************************************************
     STATE
     ********************************************************************************************************************/
    const _devices: Ref<IEquipmentMasterDataWithDocCountDTO[] | null> = ref(null)

    const state = { _devices }

    /********************************************************************************************************************
     GETTERS
     ********************************************************************************************************************/
    const devices = computed(() => _devices.value)

    const getters = { devices }

    /********************************************************************************************************************
     ACTIONS
     ********************************************************************************************************************/
    /** Reloads the currently active list of "my devices" */
    function refresh(): Promise<IEquipmentMasterDataWithDocCountDTO[]> {
        const api = new EquipmentApi
        return api.getMyEquipments()
            .then(response => _devices.value = response.data)
    }

    function reset() {
        DEBUG('resetting store: My Equipments')
        _devices.value = null
    }

    const actions = { refresh, reset }

    /********************************************************************************************************************
     INIT
     ********************************************************************************************************************/
    new UserDependentStore(() => refresh(), () => reset())

    /********************************************************************************************************************
     MISC
     ********************************************************************************************************************/
    // Setup dependency on user store
    return { ...state, ...getters, ...actions  }
})